<div *ngIf="blockScreen" class="overlay"></div>
